import { render, staticRenderFns } from "./CaseSummary.vue?vue&type=template&id=b1c15e78&"
import script from "./CaseSummary.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaseSummary.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CaseSummary.vue?vue&type=style&index=0&id=b1c15e78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDivider,VIcon,VRow,VTextarea})
